A person who applied for a position at a company.

If the same person applies to multiple hirers they will have distinct `Candidate` objects created.
